<template>
  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting employee's hours...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <v-layout row align-center>
          <h1 class="display-1 mr-2">Period:</h1>
          <template>
            <v-flex>
              <v-menu
                ref="startDateMenu"
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="Start Date"
                    format="dddd, MM DD YYYY"
                    @change="value => startDate = value"
                    :value="dateFormatted(startDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :show-current="endDate"
                  v-model="startDate"
                  @input="startDateMenu = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <template>
            <v-flex>
              <v-menu
                ref="endDateMenu"
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="End Date"
                    format="dddd, MM DD YYYY"
                    @change="value => endDate = value"
                    :value="dateFormatted(endDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :show-current="startDate"
                  v-model="endDate"
                  @input="endDateMenu = false"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <v-btn @click="reGetRecords" color="primary">
            Change Dates
          </v-btn>
        </v-layout>

        <v-data-table
          :items="report"
          :headers="headers"
          item-key="worksite_id"
          class="elevation-1"
        >
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>
                <router-link :to="{ name: 'employeeDetail', params: { employeeId: item.employee_id } }" target="_blank">
                  {{ item.display_name }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'clientBusinessDetail', params: { clientBusinessId: item.worksite_parent_id } }" target="_blank">
                  {{ item.worksite_name }}
                </router-link>
              </td>
              <td>
                {{ item.hours_worked }}
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import {mapState, mapGetters} from 'vuex';
  // import {ExportToCsv} from 'export-to-csv';
  import EmployeeName from '@/components/hr/employee-name.vue'

  export default {
    components: { EmployeeName, },
    computed: {
      ...mapState('userAuth', ['user']),
      //computedOffset: function () {
      //  return this.limit * (this.page - 1)
      //},
      //pageLength: function () {
      //  return Math.ceil(this.queryTotal / this.limit)
      //},
      formattedQuery: function() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          employeeID: this.employeeID,
          worksiteID: this.worksiteID,
          //limit: this.limit,
          //offset: this.computedOffset,
          //page: this.page,
        };
      },
    },
    created() {
      this.setUp();
    },
    watch: {
      //'page': {
      //  handler(value) {
      //    if (value != this.$route.query.page) {
      //      this.reGetRecords()
      //    } else {
      //    }
      //  }
      //}
    },
    data: function() {
      return {
        limit: 40,
        page: 1,
        startDateMenu: false,
        endDateMenu: false,
        startDate: this.$moment()
          .subtract(2, 'weeks')
          .format('YYYY-MM-DD'),
        endDate: this.$moment()
          .subtract(1, 'weeks')
          .format('YYYY-MM-DD'),
        reportsPending: true,
        loadingCsv: false,
        report: {},
        employeeID: null,
        worksiteID: null,
        //defaultSort: {
        //  sortBy: 'order',
        //  rowsPerPage: -1, //all
        //},
        headers: [
          { text: 'Employee', value: 'last_name', sortable: true },
          { text: 'Location', value: 'worksite_id', sortable: true },
          { text: 'Hours Worked', value: 'hours_worked', sortable: true },
        ],
      };
    },

    methods: {
      setUp: function() {
        this.startDate = this.$route.query.startDate || this.startDate;
        this.endDate = this.$route.query.endDate || this.endDate;
        this.employeeID = this.$route.query.employeeID || this.employeeID;
        this.worksiteID = this.$route.query.worksiteID || this.worksiteID;

        this.getReports();
      },

      dateFormatted: function(date) {
        return date ? this.$moment(date).format('dddd, MMMM D') : '';
      },

      getReports: function() {
        this.reportsPending = true;
        this.$store
          .dispatch('reports/getEmployeeHoursAtLocation', this.formattedQuery)
          .then(report => {
            console.log(report)
            this.report = report
          })
          .catch(err => {
            console.log(err);
          })
          .finally(res => {
            this.reportsPending = false;
          });
      },
      reGetRecords: function() {
        this.getReports()
      },
    },
  };
</script>
